import styled, { keyframes, css } from "styled-components";

const COLUMN_SPACING = "32px";

export const queuePulse = keyframes`
  0%   { background-color: transparent; }
  15%  { background-color: rgba(238, 238, 238, 0.25); }
  100% { background-color: transparent; }
`;

export const QueueButtonWrapper = styled.span`
  display: inline-flex;
  border-radius: 8px;
  ${({ $pulse }) =>
    $pulse &&
    css`
      animation: ${queuePulse} 2s ease-out;
    `}
`;

export const MobileContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 99vw;
  max-height: 380px;
  z-index: ${props => (props.hasAutoCompleteResults ? 0 : 150)};
  color: ${props => props.theme.white};

  .mobile-visualization {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: 64px;
    background: linear-gradient(#1f1f1f00, #1f1f1f, #1f1f1f);
  }
  .mobile-waveform {
    grid-column: 1/6;
    grid-row: 1/2;
  }
  .playback-control {
    grid-column: 1/2;
    grid-row: 1/2;
    /* place-self: center; */
    padding-left: 19px;
    /* Check Waveform component and added 1 more z-index value */
    z-index: 161;

    .toggle-playback {
      max-width: 42px;
      cursor: pointer;
      padding: 10px;
      box-sizing: content-box;
    }
  }
  .details-and-queue {
    background-color: ${props => props.theme.backgroundDark};
  }

  .mobile-details-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
  }
  .mobile-details {
    grid-column: 1/5;
    padding-left: 34px;
  }
  .separator {
    width: auto;
    height: 2px;
    display: block;
    background-color: ${props => props.theme.backgroundTag};
    margin: 17px 20px 0;
  }
  .mobile-title {
    font-size: ${props => props.theme.p4b.fs};
    font-family: ${props => props.theme.p4b.ff};
    color: ${props => props.theme.textLight};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
  .mobile-album {
    font-size: ${props => props.theme.p4r.fs};
    font-family: ${props => props.theme.p4r.ff};
    color: ${props => props.theme.textDark};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
      color: ${props => props.theme.textLight};
    }
  }
  .mobile-playlist-toggle {
    grid-column: 5/6;
    max-width: 21px;
    height: auto;
    cursor: pointer;
    padding-right: 66px;
    justify-self: right;
    opacity: 0.55;
    transition: 0.2s opacity ease-out;
  }
  .active-playlist-button {
    opacity: 1;
  }
`;

export const DrawerContainer = styled.div`
  .ant-drawer-content {
    overflow: visible;
  }

  /* Drop Antd's default drawer drop-shadow above the player bar.
     The intentional bg-matching gradient (BrowseFadeOverlay) stays.
     Selector specificity matches Antd's own rule so no !important needed. */
  .ant-drawer-bottom.ant-drawer-open .ant-drawer-content-wrapper {
    box-shadow: none;
  }
`;

export const Container = styled.div`
  position: absolute;
  top: 0px;
  width: 100%;
  display: grid;
  grid-template-rows: auto;

  .player-container {
    width: ${props =>
      props.showTrackDetails
        ? "100%"
        : `calc(100% - ${props.theme.sidebar.width})`};
    display: grid;
    grid-column-gap: ${COLUMN_SPACING};
    background-color: ${props => props.theme.backgroundDark};
    padding: 18px 40px;
    padding-left: ${props => (props.showTrackDetails ? "40px" : "0px")};

    @media only screen and (min-width: 780px) {
      grid-template-columns: ${props =>
          props.showTrackDetails ? "186px" : "0px"} auto 1fr auto auto;
    }
    @media only screen and (min-width: 1200px) {
      grid-template-columns: ${props =>
          props.showTrackDetails ? "186px" : "0px"} auto 1fr auto auto;
    }

    audio {
      display: none;
    }

    .details {
      display: ${props => (props.showTrackDetails ? "grid" : "none")};
      grid-template-columns: 54px auto;
      grid-template-rows: 32px 32px;
      grid-column-gap: 10px;
      justify-self: start;
      place-items: center;
      width: 186px;

      .thumbnail {
        grid-row: 1/3;
        justify-self: start;
        width: 54px;
        height: 54px;
        border-radius: 4px;
      }

      .title {
        grid-row: 1/2;
        grid-column: 2/3;
        justify-self: start;
        align-self: end;
        font-size: ${props => props.theme.p3b.fs};
        font-family: ${props => props.theme.p3b.ff};
        color: ${props => props.theme.textLight};
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        cursor: pointer;
        width: 100%;

        &:hover {
          text-decoration: underline;
        }
      }

      .album {
        grid-row: 2/3;
        grid-column: 2/3;
        justify-self: start;
        align-self: start;
        font-size: ${props => props.theme.p3r.fs};
        font-family: ${props => props.theme.p3r.ff};
        color: ${props => props.theme.textGrey};
        cursor: pointer;
        width: 100%;

        .album-name {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        &:hover {
          text-decoration: underline;
          color: ${props => props.theme.textLight};
        }
      }
    }

    .duration {
      display: none;
      justify-content: center;
      align-items: center;
      font-size: ${props => props.theme.p4r.fs};
      font-family: ${props => props.theme.p4r.ff};
      color: ${props => props.theme.textGrey};
      white-space: nowrap;

      @media only screen and (min-width: 1000px) {
        display: flex;
      }
    }
    .extra-controls {
      display: flex;
      align-items: center;
      position: relative;
      gap: 12px;

      @media only screen and (min-width: 780px) {
        justify-content: space-between;
      }
      @media only screen and (min-width: 1200px) {
        justify-content: space-evenly;
      }
    }

    .volume {
      display: flex;
      align-items: center;
    }

    .ant-slider-track {
      background-color: ${props => props.theme.highlight};
      &:hover {
        background-color: ${props => props.theme.highlight};
      }
    }
    .ant-slider {
      &:hover {
        .ant-slider-track {
          background-color: ${props => props.theme.highlight};
        }
      }
    }
  }
`;

export const PlaybackControlsContainer = styled.div`
  grid-column: 2/3;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 118px;
  margin-left: -${COLUMN_SPACING};

  .change-track {
    cursor: pointer;
    max-width: 22px;
    opacity: ${props => (props.showTrackDetails ? "0.15" : "0")};
    transition: opacity 0.3s ease;
    &:hover {
      opacity: 0.7;
    }
    &:active {
      transform: scale(0.95);
    }
  }

  .active-control {
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }

  .toggle-playback {
    width: 42px;
    cursor: pointer;

    &:hover {
      filter: brightness(1.2);
    }
    &:active {
      transform: scale(0.95);
    }
  }

  &:hover .change-track {
    opacity: 0.15;

    &.active-control:hover {
      opacity: 0.7;
    }
  }
`;
